module.exports = __webpack_public_path__ + "static/img/VDappScenarios1-2.b7ab16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios1-2.png
// module id = CKTl
// module chunks = 0